<template>
  <div id="app">
    <div class="map--container" v-if="countriesJSON && mapHeight">
      <l-map
        :center="center"
        :zoom="2"
        :minZoom="2"
        :maxZoom="5"
        class="map--component"
        v-bind:style="{ height: mapHeight + 'px' }"
        :options="mapOptions"
      >
        <img v-on:click="clickTutorial" class="map--logo" src="../assets/logo.svg" alt="Copa Map Logo" />
        <l-choropleth-layer
          :data="legend"
          @open="click"
          titleKey="country_name"
          idKey="country_id"
          :value="value"
          geojsonIdKey="dpto"
          :geojson="countriesJSON"
          :colorScale="colorScale"
          :strokeColor="strokeColor"
          :currentStrokeColor="currentStrokeColor"
        >
        </l-choropleth-layer>
        <div v-if="titleVisible" class="map--title">Select A Country</div>
        <l-control-zoom position="bottomleft"></l-control-zoom>
        <svg id="pattern" xmlns="http://www.w3.org/2000/svg" version="1.1">
          <defs>
            <pattern id="image" width="1" height="1" viewBox="0 0 100 100" preserveAspectRatio="none">
              <image
                xlink:href="https://map-api-uploads.s3-eu-west-1.amazonaws.com/background-combined.png"
                width="716"
                height="738"
                preserveAspectRatio="none"
              ></image>
            </pattern>
          </defs>
        </svg>
      </l-map>
    </div>
  </div>
</template>

<script>
import ChoroplethLayer from "./ChoroplethLayer";
import { LMap, LControlZoom } from "vue2-leaflet";

export default {
  name: "app",
  components: {
    "l-map": LMap,
    "l-choropleth-layer": ChoroplethLayer,
    "l-control-zoom": LControlZoom
  },
  props: {
    countriesJSON: Object,
    legend: Array,
    open: Function
  },

  methods: {
    click(feature) {
      if (feature && feature.properties && !feature.properties.disabled) {
        this.titleVisible = false;
        this.$emit("open", feature);
      }
    },
    clickTutorial() {
      this.titleVisible = true;
      this.$emit("openTutorial");
    },
    setMapHeight() {
      if (window.innerHeight < 600) {
        this.mapHeight = window.innerHeight - 20; // less padding on mobile devices
      } else {
        this.mapHeight = window.innerHeight - 40;
      }
    }
  },

  mounted() {
    this.setMapHeight();
    this.$nextTick(function() {
      window.addEventListener("resize", this.setMapHeight);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setMapHeight);
  },

  data() {
    return {
      mapHeight: undefined,
      bottomright: "bottomright",
      colorScale: ["E63C11", "rgba(204, 81, 49, 0.85)"],
      value: {
        key: "articleCount",
        metric: "articles"
      },
      titleVisible: true,
      modalType: null,
      mapOptions: {
        attributionControl: false
      },
      modalVisible: false,
      countryInformation: {},
      topright: "topright",
      strokeColor: "E63C11",
      currentStrokeColor: "fff",
      center: [33.169693, 10.057707]
    };
  }
};
</script>
<style lang="scss">
@import "../style/leaflet.css";
@import "../style/components/map";
</style>
